/**
 * Iter405 — central role-label resolver.
 * Picks the most specific role first. Multiple flags can be true (e.g. an
 * admin who also runs a realtor account), so order matters.
 */
export const getUserRoleLabel = (user) => {
  if (!user) return { text: 'User', icon: '👤' };
  if (user.role === 'superadmin') return { text: 'Super Admin', icon: '👑' };
  if (user.role === 'admin') return { text: 'Admin', icon: '🛡️' };
  if (user.is_realtor) return { text: 'Estate Agent', icon: '🏠' };
  if (user.is_gallery_dealer) return { text: 'Gallery', icon: '🚗' };
  if (user.role === 'provider' || user.is_provider) return { text: 'Service Provider', icon: '💼' };
  return { text: 'User', icon: '👤' };
};

export const formatUserRoleLabel = (user) => {
  const { text, icon } = getUserRoleLabel(user);
  return `${icon} ${text}`;
};
